<template>
  <!-- 我的收益 -->
  <div class="container">
    <Title-b :title="$t('Side.Myearnings')" />
    <br>
    <!-- <p class="p">我的收益</p> -->
    <div class="one">
      <!-- <div class="blue">
        <div class="money">
          <p>{{$t('PromotionCenter.AllMoney')}}</p>
          <p>
            {{ total.SumFree}}
          </p>
        </div>
      </div>
      &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; -->
      <div class="blue">
        <div class="money">
          <p>{{$t('PromotionCenter.SumWeight')}}</p>
          <p>
            {{ total.SumWeight}}
          </p>
        </div>
      </div>
       &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
      <div class="red">
        <div class="money">
          <p>{{$t('PromotionCenter.OrderNum')}}</p>
          <p>{{ total.OrderCount}}</p>
        </div>
      </div>
    </div>
    <Title-b :title="$t('PromotionCenter.recommendRecord')" style="margin-top: 20px;"/>
    <br>
    <DatePicker ref="startEndTime" v-model="startEndTime" type="daterange" split-panels @on-change="changeDate"></DatePicker>
    <Button type="primary" icon="ios-search" @click="search">{{$t('PromotionCenter.Search')}}</Button>
    <Table :loading="loading" id="table" border :columns="tableColumns" :data="tableData"></Table>

    <!-- 查看详情 -->
    <r-mask :title="$t('PromotionCenter.Details')" :isShowModal="viewDetails" @closeMask="closeDetails">
      <div style="margin-bottom: 10px;">
        <Select v-model="agent" clearable filterable class="name">
          <Option v-for="item in nameList" :value="item.id" :key="item.id">{{ item.userName }}</Option>
        </Select>
        <Button type="info" icon="ios-search" @click="getNewList">{{$t('PromotionCenter.Search')}}</Button>
        <Button type="primary" icon="md-cloud-download" @click="exportExcel">{{$t('PromotionCenter.download')}}</Button>
      </div>
      <Table border :columns="columns2" :data="detailsData"></Table>
    </r-mask>

    <!-- <div style="margin: 10px 0 0 400px">
      <Page :total="AllCount" :current="pageNo" :page-size="pageSize" @on-change="onpage" show-total show-elevator class="page"/>
    </div> -->

    <Modal v-model="modal1" title="提现">
      <Button @click="(modal2 = true), (modal1 = false)">{{$t('Withdrawaltobalance')}}</Button>
      <Button @click="(modal3=true),(modal1=false)">{{$t('WithdrawcashtoAlipay')}}</Button>
    </Modal>
    <Modal v-model="modal2" class="Modal" @on-ok="ApplyWithDraw()">
      <!-- 提现到余额 -->
      <div style="margin: 10px 10px">
        金額：<Input v-model="form1.value1" disabled :placeholder="$t('Pleaseentertheamount')" style="width: 200px"/>
      </div>
      <div style="margin: 10px 0px">
        {{$t('PromotionCenter.UserID')}}ID：<Input v-model="form1.value2" disabled :placeholder="$t('PleaseentermemberID')" style="width: 200px"/>
      </div>
      <div style="margin: 10px 10px">
        {{$t('BZ')}}：<Input v-model="form1.value3" :placeholder="$t('Myorder.Pleaseenter')" style="width: 200px"/>
      </div>
    </Modal>
    <Modal v-model="modal3" class="Modal" @on-ok="ApplyWithDraw()">
      <!-- 提现到支付宝 -->
      <div style="margin: 10px 10px">
        金额：<Input v-model="form1.value1" disabled :placeholder="$t('Pleaseentertheamount')" style="width: 200px"/>
      </div>
      <div style="margin: 10px 0px">
        {{$t('PromotionCenter.UserID')}}ID：<Input v-model="form1.value2" disabled :placeholder="$t('PleaseentermemberID')" style="width: 200px"/>
      </div>
      <div style="margin: 10px 0px">
        {{$t('login.yh')}}：<Input v-model="form2.value3" :placeholder="$t('register.two')" style="width: 200px"/>
      </div>
      <div style="margin: 10px 10px">
        {{$t('BZ')}}：<Input v-model="form2.value4" :placeholder="$t('Myorder.Pleaseenter')" style="width: 200px" />
      </div>
    </Modal>
  </div>
</template>
<script>
export default {
  data() {
    return {
      startEndTime: '',
      allorder: {},
      pageNo:1,
      AllCount:0,
      pageSize:10,
      modal1: false,
      modal2: false,
      modal3: false,
      form1: {
        value1: "",
        value2: "",
        value3: "",
      },
      form2: {
        value1: "",
        value2: "",
        value3: "",
        value4: "",
      },
      is: true,
      params: {},
      total: {},
      tableData: [],
      excelData:[],
      loading: true,
      detailsData: [],
      viewDetails: false,
      nameList: [],
      agent: "",
      timerBarId: 0,
      tableColumns: [
        { title: this.$t('Myorder.Prescription'), key: 'timeBarName', align: 'center' },
        { title: this.$t('PromotionCenter.FeeStyle'), key: 'tcubes', align: 'center'},
        { title: this.$t('PromotionCenter.TotalFreight'), key: 'SumFree', align: 'center' },
        { title: this.$t('PromotionCenter.SumWeight'), key: 'SumWeight', align: 'center' },
        { title: this.$t('PromotionCenter.OrderNum'), key: 'OrderCount', align: 'center'},
        { title: this.$t('PromotionCenter.operation'), key: 'tcubes', align: 'center',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.showDetails(params.row.ID)
                  }
                }
              },this.$t('PromotionCenter.Details')),
            ]);
          }
        },
      ],
      columns2: [
        { title: this.$t('PromotionCenter.AgentName'), key: 'up_memberName', align: 'center' },
        { title: this.$t('Myorder.Ordernumber'), key: 'id', align: 'center' },
        { title: this.$t('Home.Good'), key: 'member_id', align: 'center', width: 90 },
        { title: this.$t('PromotionCenter.UserMC'), key: 'username', align: 'center' },
        { title: this.$t('PromotionCenter.AgentType'), key: 'roles', align: 'center', width: 90 },
        { title: this.$t('Myorder.Prescription'), key: 'timeBarName', align: 'center', width: 140},
        { title: this.$t('PromotionCenter.FeeStyle'), key: 'tcubes', align: 'center', width: 90 },
        { title: this.$t('PromotionCenter.TotalFreight'), key: 'z_fare', align: 'center', width: 80 },
        { title: this.$t('PromotionCenter.SumWeight'), key: 'z_weight', align: 'center', width: 80 },
        { title: this.$t('PromotionCenter.OrderTime'), key: 'order_time', align: 'center', width: 150 }
      ]
    };
  },
  mounted() {
    // this.form1.value2 = localStorage.getItem("userID");
    // this.QueryIncome();
    this.getDefaultTime()
    this.getTotalNum()
    this.getListData()
    this.getUserType()
  },
  methods: {

    // 获取当前用户身份
    getUserType() {
      let params = { member: localStorage.getItem("userID") };
      this.$post('/getUserInfo',params).then((res) => {
        if(res.data.State) {
          if(res.data.ReturnJson2 !== "1") {
            this.columns2 = this.columns.filter(col => col.key !== "ReferenceNumber")
          }
        }
      })
    },

    // 默认七天内
    getDefaultTime() {
      var time = new Date()
      var month = time.getMonth() + 1
      var day = time.getDate()
      let nowTime = time.getFullYear() + '-' + (month < 10 ? '0' + month : month) + '-' + (day < 10 ? '0' + day : day)
      let startTime = new Date(time.getTime() - 6*24*60*60*1000)
      let m = (startTime.getMonth() + 1),mm = '-'+(m<10?'0'+m:m)
      let d = startTime.getDate(),dd = '-'+(d<10?'0'+d:d)
      let startDate = startTime.getFullYear() + mm + dd
      this.startEndTime = [startDate,nowTime]
      this.$set(this.params,'BeginTime',startDate)
      this.$set(this.params,'EndTime',nowTime)
    },
    changeDate(date) {
      this.$set(this.params,'BeginTime',date[0])
      this.$set(this.params,'EndTime',date[1])
    },
    getTotalNum() {
      let JsonData = {
        MemberId: localStorage.getItem("userID")
      }
      this.$post('/SunAgentOrder',JsonData).then((res) => {
        if(res.data.State) {
          this.total = JSON.parse(res.data.ReturnJson)[0];
        } else {
          this.$Message.error(res.MsgText)
        }
      })
    },

    search() {
      this.getListData()
    },

    getListData() {
      this.loading = true
      this.$set(this.params,'MemberId',localStorage.getItem("userID"))
      this.$post('/SunAgentOrderByTimeBer',this.params).then((res) => {
        if(res.data.State) {
          this.loading = false
          this.tableData = JSON.parse(res.data.ReturnJson);
        } else {
          this.$Message.error(res.MsgText)
        }
      })
    },
    showDetails(ID) {
      this.timerBarId = ID
      let JsonData = {
        MemberId: localStorage.getItem("userID"),
        TimeberId: this.timerBarId,
        BeginTime: this.params.BeginTime,
        EndTime: this.params.EndTime
      }
      this.$post('/GetAgentOrderList',JsonData).then((res) => {
        if(res.data.State) {
          this.getNameList()
          this.detailsData = JSON.parse(res.data.ReturnJson)
          this.viewDetails = true
        } else {
          this.$Message.error(res.MsgText)
        }
      })
    },

    //获取代理人下拉框
    getNameList() {
      let JsonData = {
        MemberId: localStorage.getItem("userID"),
        TimeberId: this.timerBarId,
        BeginTime: this.params.BeginTime,
        EndTime: this.params.EndTime
      }
      this.$post('/GetAgentOrderSelect',JsonData).then((res) => {
        if(res.data.State) {
          this.nameList = JSON.parse(res.data.ReturnJson)
        }
      })
    },
    getNewList() {
      let JsonData = {
        MemberId: localStorage.getItem("userID"),
        TimeberId: this.timerBarId,
        BeginTime: this.params.BeginTime,
        EndTime: this.params.EndTime,
        UpMemberId: this.agent
      }
      this.$post('/GetAgentOrderList',JsonData).then((res) => {
        if(res.data.State) {
          this.detailsData = JSON.parse(res.data.ReturnJson)
        } else {
          this.$Message.error(res.MsgText)
        }
      })
    },

    //导出excel
    exportExcel() {
      this.excelData = this.detailsData; //你要导出的数据list。
      this.export2Excel();
    },
    export2Excel() {
      var that = this;
      require.ensure([], () => {
        const { export_json_to_excel } = require("../../../excel/Export2Excel"); //这里必须使用绝对路径，根据自己的命名和路径
        const tHeader = [
          this.$t('PromotionCenter.AgentName'),
          this.$t('Myorder.Ordernumber'),
          this.$t('Home.Good'),
          this.$t('PromotionCenter.UserMC'),
          this.$t('PromotionCenter.AgentType'),
          this.$t('Myorder.Prescription'),
          this.$t('PromotionCenter.FeeStyle'),
          this.$t('PromotionCenter.TotalFreight'),
          this.$t('PromotionCenter.SumWeight'),
          this.$t('PromotionCenter.OrderTime')
        ]; // 导出的表头名
        const filterVal = [
          "up_memberName",
          "id",
          "member_id",
          "username",
          "roles",
          "timeBarName",
          "tcubes",
          "z_fare",
          "z_weight",
          "order_time"
        ]; // 导出的表头字段名
        const list = that.excelData;
        // that.excelData为传入的数据
        const data = that.formatJson(filterVal, list);
        export_json_to_excel(tHeader, data, `下单记录`); // 导出的表格名称，根据需要自己命名
        // tHeader为导出Excel表头名称，`xxxxxx`即为导出Excel名称
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j])); 
    },
    closeDetails() {
      this.agent = ""
      this.nameList = []
      this.viewDetails = false
    }
    // tixian(item){
    //   this.arrId = item.OrderId
    //   this.modal1 = true
    // },
    // onpage(pageNo){
    //   this.pageNo = pageNo;
    //   this.QueryIncome();
    // },
    // 查询所以返利信息
    // async QueryIncome() {
    //   const params = {
    //     MemberId: localStorage.getItem("userID"),
    //     pageIndex: (this.pageNo - 1) * this.pageSize, // 每页条数
    //     limit: this.pageSize,   // 第几页
    //   };
    //   const { data } = await this.$post("GetAgentOrderList", params);
    //   if (data.State) {
    //     this.allorder = JSON.parse(data.ReturnJson);
    //     this.AllCount = parseInt(data.MsgText)
    //     this.addordercout = JSON.parse(data.ReturnJson).IncomeInfo
    //     this.form1.value1 = this.allorder.AllProfit;
    //     this.allorder.IncomeInfo.forEach((item,index) => {
    //       this.arrId[index] = item.OrderId
    //     })
    //   }
    // },
    // 提现接口
    // async ApplyWithDraw() {
    //   // this.arrId = this.arrId.join(',')
    //   const obj = {
    //     WithDrawMoney: this.form1.value1,
    //     MemberId: localStorage.getItem("userID") * 1,
    //     Remarks: this.form1.value3,
    //     WithDrawType: "提現到余額",
    //     WithDrawAccount: localStorage.getItem("userID") * 1,
    //     OrderId: this.arrId,
    //   };
    //   const {data} = await this.$post("ApplyWithDraw", obj);
    //     this.$Message.error(data.MsgText);
    // },
    //         const obj = {
    //         WithDrawMoney: this.form.WithDrawMoney,
    //         MemberId: localStorage.getItem("userID"),
    //         Remarks: this.form.Remarks,
    //         WithDrawType: "提现到余额",
    //         WithDrawAccount: localStorage.getItem("userID"),
    //         OrderId: this.form.OrderId
    //       };  ApplyWithDraw

    //      form: {
    //             WithDrawMoney: "",
    //             MemberId: localStorage.getItem("userID"),
    //             WithDrawImage: "",
    //             Remarks: "",
    //             WithDrawType: "提现到微信",
    //             WithDrawAccount: localStorage.getItem("userID"),
    //             NickName: "",
    //             Mobile: "",
    //             OrderId: ''
    //           },QueryIncome

    // if(this.form2.value1 == ""){
    //     this.$Message.error("请输入金额！");
    //     this.is=false;
    //     return false;
    // }else if(this.form2.value2 == ""){
    //     this.$Message.error("请输入会员ID！");
    //     this.is=false;
    //     return false;
    // }else if(this.form2.value3 == ""){
    //     this.$Message.error("请输入用户名！");
    //     this.is=false;
    //     return false;
    // }
  },
};
</script>
<style lang="scss" scoped>
.container {
  width: 1069px;
  height: 700px;
  border-radius: 5px;
  background: #fff;
  padding: 19px 17px;
  .one {
    display: flex;
    flex-direction: row;
    // margin: 0 0 0 281px;
    .blue {
      width: 80%;
      // width: 210px;
      height: 124px;
      background: linear-gradient(90deg, #4096ee 0%, #7abcff 100%);
      // border-radius: 5px;
      position: relative;
      .money {
        cursor: pointer;
        margin: 27px 0 0 0;
        text-align: center;
        p {
          color: #fff;
        }
        p:nth-child(1) {
          font-size: 20px;
        }
        p:nth-child(2) {
          font-size: 30px;
          font-weight: bold;
        }
      }
    }
    .red {
      width: 80%;
      // width: 210px;
      height: 124px;
      background: linear-gradient(90deg, #ff5e70 0%, #ffa88e 100%);
      // border-radius: 5px;
      // margin: 0 0 0 84px;
      position: relative;
      .money {
        cursor: pointer;
        margin: 27px 0 0 0;
        text-align: center;
        p {
          color: #fff;
        }
        p:nth-child(1) {
          font-size: 20px;
        }
        p:nth-child(2) {
          font-size: 30px;
          font-weight: bold;
        }
        p:nth-child(3) {
          width: 60px;
          height: 30px;
          background: #fff;
          border-radius: 5px;
          font-size: 20px;
          color: #ff6070;
          margin: 0 0 0 75px;
        }
      }
    }
  }
}

/deep/.modal-bag .modal-content {
  width: 75% !important;
}

#table {
  margin-top: 10px;
}

.name {
  width: 200px;
}
</style>


// WEBPACK FOOTER //
// src/pages/view/extension/Myearnings.vue